import { render } from "./FormComponent.vue?vue&type=template&id=2a8472e2&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "@/assets/css/general/form-style.css?vue&type=style&index=0&id=2a8472e2&scoped=true&lang=css&external"
import "@/assets/css/general/tab-style.css?vue&type=style&index=1&id=2a8472e2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8472e2"]])

export default __exports__